import { FvButton, Icon } from '@fv/client-components'

import { Pinline } from '@/components/Pinline'
import { PricePlain } from '@/components/shared/Price'
import { usePermissions } from '@/features/auth'

import type { RouteGuideView } from './hooks'

type Props = Pick<RouteGuideView, 'bookTpeRate' | 'tpeRate'>

export const BookTpeButton = ({ bookTpeRate, tpeRate }: Props) => {
  const { canBook } = usePermissions()
  if (!tpeRate || !canBook) return null

  return (
    <div className="flex items-center gap-x-2 border border-fv-blue-200 bg-fv-blue-50 px-4 py-3">
      <Icon icon="step-forward" className="text-fv-orange-bright" />
      <span>Skip your route guide and book now</span>
      <Pinline className="flex-1 !border-fv-blue-300" dotted />
      <FvButton
        theme="primary"
        icon="truck"
        loading={bookTpeRate.isPending}
        onClick={() => {
          if (
            !window.confirm(
              'This will end the route guide and book this shipment with CHR. Do you want to continue?',
            )
          ) {
            return
          }
          bookTpeRate.mutate(undefined)
        }}
      >
        C.H. Robinson
        {tpeRate.amount !== null && (
          <>
            {' '}
            - <PricePlain amount={tpeRate.amount} />{' '}
            {tpeRate.currency.toUpperCase()}
          </>
        )}
      </FvButton>
    </div>
  )
}
